/** Query parameter used by push notification links to select today's reading. */
export const TODAY_READING_QUERY_PARAMETER = 'reading';
export const TODAY_READING_QUERY_VALUE = 'today';

/** Returns whether a URL represents a push click intended for today's reading. */
export const shouldOpenTodaysReading = (search: string): boolean =>
  new URLSearchParams(search).get(TODAY_READING_QUERY_PARAMETER) ===
  TODAY_READING_QUERY_VALUE;

/** Removes the consumed push-navigation intent while preserving other params. */
export const removeTodayReadingIntent = (url: URL): string => {
  const cleanedUrl = new URL(url.toString());
  cleanedUrl.searchParams.delete(TODAY_READING_QUERY_PARAMETER);
  return `${cleanedUrl.pathname}${cleanedUrl.search}${cleanedUrl.hash}`;
};
